export const ROOT = '/';
export const HOME = '/home';
export const DASHBOARD = '/dashboard';
export const NOT_FOUND = '/not-found';
export const TNC = '/tnc';
export const PRIVACY_POLICY = '/privacy-policy';
export const HELP = '/help';
export const SIGNIN = '/login';
export const LOGIN_BELAJAR_ID = '/login/belajar-id';
export const BELAJAR_VERIFY = '/belajar/verify';
export const BELAJAR_SCHOOL_NOT_FOUND = '/belajar/sekolah-belum-terdaftar';
export const BELAJAR_STUDENT_NO_CLASS = '/belajar/siswa-belum-dialokasikan-kelas';
export const SIGNUP = '/signup';
export const FORGOTPASSWORD = '/forgot-password';
export const FORGOTPASSWORDMETHOD = '/forgot-password-method';
export const SUCCESS_SENT_EMAIL_LINK = '/success-sent-email';
export const RESETPASSWORD = '/verify-reset-password';
export const VERIFYUSER = '/verify-user';
export const ABOUT = '/about';
export const LMS = '/learning-management-system';
export const SMS = '/school-management-system';
export const CONTACT_US = '/contact-us';
export const OAUTH = '/oauth';
export const SELECT_ROLE = '/select-role';
export const COMPLETE_PROFILE = '/complete-profile';
export const JOIN_CLASS = '/join-class';
